<div class="datetime-picker">
  <mat-form-field floatLabel="never" class="rc-mr-10">
    <input
      autocomplete="off"
      matInput
      [value]="stringifiedDate"
      (change)="onDateInput($event.target.value)"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
    />
    @if (hasError) {
      <mat-hint>
        <span class="pink" translate>
          MC_Invalid format. Valid: A date or 'now', 'now-X', '-X'; where X = number + m/h/d/M
        </span>
      </mat-hint>
    }

    <input
      autocomplete="off"
      matInput
      [value]="date"
      (dateChange)="onDateChange($event)"
      [matDatepicker]="datepicker"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      style="display: none"
    />

    <mat-datepicker-toggle [for]="datepicker" matIconSuffix>
      <mat-icon matDatepickerToggleIcon>
        <rotec-icon-v2 svgIcon="calendar" color="gray-lighter" />
      </mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker #datepicker />
  </mat-form-field>

  <mat-form-field floatLabel="never">
    <input
      matInput
      [matTimepicker]="timepicker"
      [ngModel]="date"
      (ngModelChange)="onDateInput($event)"
      [placeholder]="timepickerPlaceholder$ | async"
      [disabled]="!(enableTimepicker$ | async)"
    />
    <mat-timepicker #timepicker />
    <mat-timepicker-toggle [for]="timepicker" matIconSuffix>
      <mat-icon matTimepickerToggleIcon>
        <rotec-icon-v2
          svgIcon="time"
          [color]="(enableTimepicker$ | async) ? 'gray-lighter' : 'gray-dark'"
        />
      </mat-icon>
    </mat-timepicker-toggle>
  </mat-form-field>
</div>
